import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import logo from "../assets/ramsden-light.png"
import { motion } from "framer-motion"

export default function CandidateLayout({ children }) {
    const navigate = useNavigate()

    const handleLogout = async () => {
        try {
            await fetch("/api/v1/candidates/sign_out", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                credentials: "include",
            })
            window.location.href = "/"
        } catch (error) {
            console.error("Logout failed", error)
        }
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#F7F2F8] via-[#FDF7FA] to-[#F3F3F3] flex flex-col">
            {/* Header */}
            <header className="w-full bg-white/80 backdrop-blur-sm border-b border-gray-200 shadow-sm px-6 py-4 flex justify-between items-center z-10">
                <div className="flex items-center gap-2">
                    <img src={logo} alt="Ramsden logo" className="h-6 w-auto" />
                    <span className="text-lg font-semibold text-[#8C3161] tracking-tight">
                        Candidate Portal
                    </span>
                </div>
                <button
                    onClick={handleLogout}
                    className="text-sm text-[#8C3161] underline hover:text-[#8C3161]/80 transition"
                >
                    Log out
                </button>
            </header>

            {/* Page Content */}
            <main className="flex-1 px-4 md:px-8 py-10 max-w-3xl w-full mx-auto">
                <motion.div
                    className="mb-6"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <h1 className="text-3xl font-bold text-[#8C3161] tracking-tight">My Profile</h1>
                </motion.div>

                <motion.div
                    className="bg-white/80 backdrop-blur-md border border-gray-200 rounded-2xl shadow-xl p-6"
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.1 }}
                >
                    {children}
                </motion.div>
            </main>
        </div>
    )
}
